export default __webpack_public_path__ + "static/media/blueprint.4bd6851f.svg";